export const UserType = {
  ADMIN: 'admin',
  LEAD: 'lead',
};
